<template>
  <VDialog v-model="isOpen" max-width="1000">
    <VCard class="create-dialog__wrap">
      <div class="create-dialog__header">
        <div class="create-dialog__header_title">
          {{ $t('createQrDialogTitle') }}
        </div>
        <div @click="closeDialog" class="create-dialog__close">
          <img :src="require('@/assets/img/qr/create/close.svg')" alt="close">
        </div>
      </div>

      <div class="create-dialog__main">
        <VRow no-gutters class="settings">
          <VCol cols="12">
            <div class="settings-item">
              <div class="create-dialog__main_title">
                {{ $t('bannerSize') }}:
              </div>
              <VMenu v-model="isMenuOpen" offset-y>
                <template v-slot:activator="{ on, attrs }">
                  <VTextField
                    :value="selectedSizeLabel"
                    :label="$t('selectBannerSize')"
                    readonly
                    dense
                    outlined
                    class="select-size-banner-field"
                    :append-icon="isMenuOpen ? 'mdi-chevron-up' : 'mdi-chevron-down'"
                    v-bind="attrs"
                    v-on="on"
                    @click:append="isMenuOpen = !isMenuOpen"
                  />
                </template>

                <VList>
                  <template v-for="(group, index) in groupedSizes">
                    <VListItem :key="group.category" disabled>
                      <VListItemContent>
                        <VListItemTitle class="category-title">
                          {{ group.category }}
                        </VListItemTitle>
                      </VListItemContent>
                    </VListItem>

                    <VListItem
                      v-for="item in group.items"
                      :key="item.value"
                      @click="selectItem(item)"
                    >
                      <VListItemContent>
                        <VListItemTitle :class="{ 'selected-item': checkSelectedItem(item.value) }">
                          {{ item.label }}
                        </VListItemTitle>
                      </VListItemContent>
                      <VListItemAction v-if="checkSelectedItem(item.value)">
                        <VIcon color="primary">
                          mdi-check
                        </VIcon>
                      </VListItemAction>
                    </VListItem>

                    <VDivider v-if="shouldShowDivider(index)" :key="'divider-' + index" />
                  </template>
                </VList>
              </VMenu>
            </div>
            <div class="settings-item">
              <div class="create-dialog__main_title">
                {{ $t('bannerBackColor') }}:
              </div>
              <VTextField
                v-model="bannerBackColor"
                :label="$t('selectBannerBackColor')"
                maxlength="7"
                outlined
                dense
              >
                <template v-slot:append>
                  <VMenu offset-y>
                    <template v-slot:activator="{ on, attrs }">
                      <VBtn
                        v-bind="attrs"
                        v-on="on"
                        icon
                        class="btn-color-picker"
                        :style="setbuttonColorPickerStyle('back')"
                      />
                    </template>
                    <VCard>
                      <VColorPicker
                        v-model="bannerBackColor"
                        hide-inputs
                      />
                    </VCard>
                  </VMenu>
                </template>
              </VTextField>
            </div>
            <div class="settings-item">
              <div class="create-dialog__main_title">
                {{ $t('bannerTextColor') }}:
              </div>
              <VTextField
                v-model="bannerTextColor"
                :label="$t('selectBannerTextColor')"
                maxlength="7"
                outlined
                dense
              >
                <template v-slot:append>
                  <VMenu offset-y>
                    <template v-slot:activator="{ on, attrs }">
                      <VBtn
                        v-bind="attrs"
                        v-on="on"
                        icon
                        class="btn-color-picker"
                        :style="setbuttonColorPickerStyle('text')"
                      />
                    </template>
                    <VCard>
                      <VColorPicker
                        v-model="bannerTextColor"
                        hide-inputs
                      />
                    </VCard>
                  </VMenu>
                </template>
              </VTextField>
            </div>
          </VCol>

          <VCol cols="12" class="d-flex align-end print-service-block">
            <div>
              <div>
                {{ $t('printService') }}
              </div>
              <a :href="selectedSize.printServiceLink" target="_blank">
                {{ selectedSize.printServiceLink }}
              </a>
            </div>
          </VCol>
        </VRow>

        <VDivider vertical class="create-dialog__divider" />

        <VDivider horizontal class="create-dialog__divider-horizontal" />

        <div class="preview">
          <div class="slides">
            <div class="main-slide">
              <div @click="prevSlide" class="arrow prev-arrow">
                <template v-if="currentOrder === 0">
                  <img src="@/assets/img/qr/create/left-arrow-disabled.svg" alt="prev">
                </template>
                <template v-else>
                  <img src="@/assets/img/qr/create/left-arrow.svg" alt="prev">
                </template>
              </div>
              <div
                id="bannerMain"
                class="banner-main"
              >
                <template v-if="currentOrder === 0">
                  <div
                    class="banner"
                    :style="bannerStyles"
                  >
                    <div class="banner__content">
                      <div class="banner__content_block" :style="selectedSize.styles">
                        <div
                          class="banner__content_title"
                          :class="[ locale === 'ru' ? 'banner__content_title-ru' : 'banner__content_title-en' ]"
                        >
                          {{ $t('nowHiring') }}
                        </div>
                        <VacancyListQr
                          :vacancy-list-id="vacancyListId"
                          :url="url"
                          :qr-border="false"
                          class="qr"
                        />
                      </div>
                      <div class="banner__content_url">
                        {{ portalURL }}
                      </div>
                    </div>
                  </div>
                </template>
                <template v-else>
                  <div class="banner-main-preview">
                    <img :src="selectedSize.preview" alt="preview">
                  </div>
                </template>
              </div>
              <div @click="nextSlide" class="arrow next-arrow">
                <template v-if="currentOrder === 1">
                  <img src="@/assets/img/qr/create/right-arrow-disabled.svg" alt="next">
                </template>
                <template v-else>
                  <img src="@/assets/img/qr/create/right-arrow.svg" alt="next">
                </template>
              </div>
            </div>
            <div class="banner__previews">
              <div @click="prevSlide" class="banner-preview">
                <div
                  class="banner banner-mini"
                  :style="bannerStyles"
                >
                  <div class="banner__content banner__content-mini">
                    <div class="banner__content_block banner__content_block-mini" :style="selectedSize.styles">
                      <div class="banner__content_title banner__content_title-mini">
                        {{ $t('title1QR') }}
                        <br>
                        {{ $t('title2QR') }}
                      </div>
                      <VacancyListQr
                        class="qr-mini"
                        :vacancy-list-id="vacancyListId"
                        :url="url"
                        :qr-border="false"
                      />
                    </div>
                    <div class="banner__content-mini_url">
                      {{ portalURL }}
                    </div>
                  </div>
                </div>
                <div v-if="currentOrder === 0" class="blur-overlay">
                  <img src="@/assets/img/qr/create/check.svg" alt="preview">
                </div>
              </div>
              <div @click="nextSlide" class="banner-preview">
                <img :src="selectedSize.preview" alt="preview">
                <div v-if="currentOrder === 1" class="blur-overlay">
                  <img src="@/assets/img/qr/create/check.svg" alt="preview">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <VCardActions class="actions mt-4">
        <VBtn
          color="success"
          dark
          @click="downloadBannerAsPDF"
        >
          <img :src="require('@/assets/img/qr/create/download-white.svg')" class="mr-2" alt="">
          {{ $t('dowloadBanner') }}
        </VBtn>
        <VBtn color="white" class="action-cancel" @click="closeDialog">
          {{ $t('cancel') }}
        </VBtn>
      </VCardActions>
    </VCard>
  </VDialog>
</template>

<script>
import {
  defineComponent, computed, ref, onMounted, toRefs,
} from '@vue/composition-api';
import { useI18n } from 'vue-i18n-composable';
import VacancyListQr from '@/components/VacancyLists/VacancyListQr';
import { jsPDF } from 'jspdf';
import useCompany from '@/compositions/useCompany';
import useDomain from '@/compositions/useDomain';
import punycode from 'punycode/';
import ProximalNovaExCnBase64 from '@/assets/fonts/ProximaNovaExCn-Semibold';
import MuseoSansCyrl500base64 from '@/assets/fonts/MuseoSansCyrl-500base64';
import QRCode from 'qrcode';
import { qrBannerTypes } from '@/enums';
import useSizeOptions from '@/mixins/useSizeOptions';

export default defineComponent({
  components: { VacancyListQr },
  props: {
    value: Boolean,
    vacancyListId: {
      type: Number,
      required: true,
    },
    url: {
      type: String,
      required: true,
    },
  },
  emits: ['input'],
  setup(props, { emit }) {
    const { url } = toRefs(props);
    const { company } = useCompany();
    const { getDomain } = useDomain();
    const { t, locale } = useI18n();
    const canvasRef = ref(null);
    const domain = ref(null);

    const isMenuOpen = ref(false);

    const sizeOptions = useSizeOptions(locale, t);

    const companyId = computed(() => company.value.id);
    const frontendUrl = `${process.env.VUE_APP_FRONT_URL}/company/${companyId.value}`;

    const portalURL = computed(() => {
      return domain.value ? punycode.toUnicode(domain.value) : frontendUrl;
    });

    onMounted(async () => {
      try {
        domain.value = await getDomain();
      } catch (error) {
        if (process.env.NODE_ENV === 'development') {
          console.error('Failed to get domain:', error);
        }
        domain.value = null;
      }
    });

    const currentOrder = ref(0);

    const groupedSizes = computed(() => {
      const groups = {};
      sizeOptions.value.forEach((size) => {
        if (!groups[size.category]) groups[size.category] = [];
        groups[size.category].push(size);
      });
      return Object.keys(groups).map((category) => ({
        category,
        items: groups[category],
      }));
    });

    const selectedSize = ref(sizeOptions.value[0]);

    const checkSelectedItem = (itemValue) => {
      return selectedSize.value && selectedSize.value?.value === itemValue;
    };

    const selectedSizeLabel = computed(() => (selectedSize.value ? `${selectedSize.value.category} | ${selectedSize.value.label}` : ''));

    const selectItem = (item) => {
      selectedSize.value = item;
    };

    const bannerBackColor = ref('#F3F5F7');
    const bannerTextColor = ref('#000000');

    // Динамическое обновление стилей баннера
    const bannerStyles = computed(() => ({
      backgroundColor: bannerBackColor.value,
      color: bannerTextColor.value,
      width: selectedSize.value.sizePx?.includes('x') ? `${selectedSize.value.sizePx?.split('x')[0]}px` : '100px',
      height: selectedSize.value.sizePx?.includes('x') ? `${selectedSize.value.sizePx?.split('x')[1]}px` : '100px',
    }));

    const isOpen = computed({
      get: () => props.value,
      set: (val) => emit('input', val),
    });

    const closeDialog = () => {
      emit('input', false);
    };

    function prevSlide() {
      currentOrder.value = 0;
    }

    function nextSlide() {
      currentOrder.value = 1;
    }

    const shouldShowDivider = (index) => index !== groupedSizes.value.length - 1;

    const setbuttonColorPickerStyle = (colorName) => {
      return {
        backgroundColor: colorName === 'back' ? bannerBackColor.value : bannerTextColor.value,
        width: '24px',
        height: '24px',
        borderRadius: '50%',
      };
    };

    async function downloadBannerAsPDF() {
      const sizeMatch = selectedSize.value.realSize.match(/^(\d+\.?\d*)x(\d+\.?\d*)(mm|in|ft)$/);
      if (!sizeMatch) {
        return;
      }

      let [, height, width, unit] = sizeMatch;
      width = parseFloat(width);
      height = parseFloat(height);

      let widthMm;
      let heightMm;
      switch (unit) {
        case 'mm':
          widthMm = width;
          heightMm = height;
          break;
        case 'in':
          widthMm = width * 25.4;
          heightMm = height * 25.4;
          break;
        case 'ft':
          widthMm = width * 304.8;
          heightMm = height * 304.8;
          break;
        default:
          return;
      }
      const pdf = new jsPDF({
        orientation: widthMm > heightMm ? 'landscape' : 'portrait',
        unit: 'mm',
        format: [widthMm, heightMm],
      });

      const baseSize = 100;
      let scaleFactor = widthMm / baseSize;

      pdf.setFillColor(bannerBackColor.value);
      pdf.rect(0, 0, widthMm, heightMm, 'F');

      pdf.setTextColor(bannerTextColor.value);

      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();

      function setTitleBanner(fontSizeRu, fontSizeEn) {
        pdf.addFileToVFS('ProximaNovaExCn-Semibold.ttf', ProximalNovaExCnBase64.normal);
        pdf.addFont('ProximaNovaExCn-Semibold.ttf', 'ProximaNovaExCn-Semibold', 'normal');
        pdf.setFont('ProximaNovaExCn-Semibold');
        pdf.setFontSize(locale.value === 'ru' ? fontSizeRu * scaleFactor : fontSizeEn * scaleFactor);
      }

      function setUrlBanner(fontSize, posY) {
        pdf.addFileToVFS('MuseoSansCyrl500.ttf', MuseoSansCyrl500base64.normal);
        pdf.addFont('MuseoSansCyrl500.ttf', 'MuseoSansCyrl500', 'normal');
        pdf.setFont('MuseoSansCyrl500');
        const urlFontSize = fontSize * scaleFactor;
        pdf.setFontSize(urlFontSize);
        const urlWidth = pdf.getTextWidth(portalURL.value);
        pdf.text(portalURL.value, (pageWidth - urlWidth) / 2, posY);
      }

      async function setQrBanner(qrSizeRu, qrSizeEn, posY, posX) {
        const qrCodeSize = locale.value === 'ru' ? qrSizeRu * scaleFactor : qrSizeEn * scaleFactor;
        const qrCodeDataUrl = await QRCode.toDataURL(url.value, { width: 200 * scaleFactor });
        pdf.addImage(qrCodeDataUrl, 'PNG', posX || (pageWidth - qrCodeSize) / 2, posY, qrCodeSize, qrCodeSize);
      }

      switch (selectedSize.value.type) {
        case qrBannerTypes.SQUARE: {
          setTitleBanner(49, 60);
          const lineHeight = locale.value === 'ru' ? 13 * scaleFactor : 12 * scaleFactor;
          const title1 = t('title1QR');
          const titleWidth1 = pdf.getTextWidth(title1);
          const xPos1 = (pageWidth - titleWidth1) / 2;
          const yPos1 = 20 * scaleFactor;

          const title2 = t('title2QR');
          const titleWidth2 = pdf.getTextWidth(title2);
          const xPos2 = (pageWidth - titleWidth2) / 2;
          const yPos2 = (25 * scaleFactor) + lineHeight;

          pdf.text(title1, xPos1, yPos1);
          pdf.text(title2, xPos2, yPos2);

          await setQrBanner(30, 30, 45 * scaleFactor);
          setUrlBanner(12, 90 * scaleFactor);
          break;
        }
        case qrBannerTypes.HORIZONTAL: {
          scaleFactor = heightMm / baseSize;
          setTitleBanner(45, 91);
          const lineHeight = locale.value === 'ru' ? 16 * scaleFactor : 27 * scaleFactor;
          const title1 = t('title1QR');
          const textWidth1 = pdf.getTextWidth(title1);
          const xPos1 = (pageWidth - textWidth1) - (pageWidth / 2) + (20 * scaleFactor);
          const yPos1 = (pageHeight / 2) + (locale.value === 'ru' ? 8 * scaleFactor : 17 * scaleFactor) - lineHeight;

          const title2 = t('title2QR');
          const textWidth2 = pdf.getTextWidth(title2);
          const xPos2 = (pageWidth - textWidth2) - (pageWidth / 2) + (20 * scaleFactor);
          const yPos2 = (pageHeight / 2) + (locale.value === 'ru' ? 8 * scaleFactor : 17 * scaleFactor);

          pdf.text(title1, xPos1, yPos1);
          pdf.text(title2, xPos2, yPos2);

          await setQrBanner(25, 37,
            (pageHeight / 2) - (locale.value === 'ru' ? 17 * scaleFactor : 25 * scaleFactor),
            (pageWidth / 2) + (25 * scaleFactor));
          setUrlBanner(12, 85 * scaleFactor);
          break;
        }
        case qrBannerTypes.VERTICAL: {
          setTitleBanner(43, 71);
          const lineHeight = locale.value === 'ru' ? 13 * scaleFactor : 23 * scaleFactor;
          const title1 = t('title1QR');
          const titleWidth1 = pdf.getTextWidth(title1);
          const xPos1 = (pageWidth - titleWidth1) / 2;
          const yPos1 = (pageHeight / 2) - (35 * scaleFactor);

          const title2 = t('title2QR');
          const titleWidth2 = pdf.getTextWidth(title2);
          const xPos2 = (pageWidth - titleWidth2) / 2;
          const yPos2 = (pageHeight / 2) - (35 * scaleFactor) + lineHeight;

          pdf.text(title1, xPos1, yPos1);
          pdf.text(title2, xPos2, yPos2);

          await setQrBanner(35, 40, (pageHeight / 2) - (locale.value === 'ru' ? 10 * scaleFactor : 5 * scaleFactor));
          setUrlBanner(12, (pageHeight / 2) + (50 * scaleFactor));
          break;
        }
        default: {
          break;
        }
      }

      const pdfUrl = pdf.output('bloburl');
      window.open(pdfUrl, '_blank');
    }

    return {
      groupedSizes,
      selectItem,
      isOpen,
      bannerBackColor,
      bannerTextColor,
      selectedSize,
      bannerStyles,
      closeDialog,
      downloadBannerAsPDF,
      sizeOptions,
      canvasRef,
      portalURL,
      locale,
      nextSlide,
      prevSlide,
      currentOrder,
      isMenuOpen,
      checkSelectedItem,
      shouldShowDivider,
      selectedSizeLabel,
      setbuttonColorPickerStyle,
    };
  },
});
</script>

<style lang="scss" scoped>
.create-dialog {
  &__header {
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
    &_title {
      font-size: 24px;
      line-height: 30px;
      max-width: 80%;
      @media screen and (max-width: 599px) {
        font-size: 19px;
        line-height: 22px;
        max-width: 90%;
      }
    }
  }
  &__wrap {
    padding: 24px;
    @media screen and (max-width: 599px) {
      padding: 12px;
    }
  }
  &__main {
    display: flex;
    @media screen and (max-width: 920px) {
      flex-direction: column;
    }
    &_title{
      margin-bottom: 10px;
      font-size: 18px;
      line-height: 19.8px;
    }
  }
  &__divider {
    margin: 0 30px;
    @media screen and (max-width: 920px) {
      display: none;
    }
  }
  &__divider-horizontal {
    display: none;
    @media screen and (max-width: 920px) {
      display: block;
      width: 100%;
      margin: 30px 0;
    }
  }
  &__close {
    cursor: pointer;
  }
}

.settings {
  width: 50%;
  @media screen and (max-width: 920px) {
    width: 100%;
  }
}

.btn-color-picker {
  border: 1px solid #757575;
}

.main-slide {
  display: flex;
  align-items: center;
}

.arrow {
  cursor: pointer;
  @media screen and (max-width: 599px) {
    display: none;
  }
}

.preview {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 50%;
  @media screen and (max-width: 920px) {
    width: 100%;
  }
}
.banner {
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  border-radius: 20px;
  &__content {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 30px;
    justify-content: space-between;
    &_title {
      font-family: 'ProximaNovaExCn', 'MuseoSansCyrl';
      text-transform: uppercase;
      font-weight: 600;
    }
    &_title-ru {
      @media screen and (max-width: 428px) {
        font-size: 41px;
        line-height: 41px;
        max-width: 195px;
      }
    }
    &_title-en {
      @media screen and (max-width: 428px) {
        font-size: 51px;
        line-height: 51px;
        max-width: 120px;
      }
    }
    &_title-mini {
      font-size: 20px !important;
      line-height: 20px !important;
      @media screen and (max-width: 428px) {
        font-size: 16px !important;
        line-height: 16px !important;
      }
      @media screen and (max-width: 350px) {
        font-size: 13px !important;
        line-height: 13px !important;
      }
    }
    &_url {
      font-size: 12px;
      margin-top: 20px;
    }
  }
  &__content-mini {
    padding: 15px;
    &_url {
      font-size: 5px !important;
      margin-top: 15px;
    }
  }
  &__previews {
    display: flex;
    gap: 12px;
  }
}

.slides {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.banner-mini {
  width: 166px !important;
  height: 166px !important;
  margin: 0px !important;
  border-radius: 12px;
  @media screen and (max-width: 428px) {
    width: 140px !important;
    height: 140px !important;
  }
  @media screen and (max-width: 350px) {
    width: 120px !important;
    height: 120px !important;
  }
}

.banner-preview {
  cursor: pointer;
  position: relative;
  width: 166px;
  height: 166px;
  border-radius: 10px;
  @media screen and (max-width: 428px) {
    width: 140px;
    height: 140px;
  }
  @media screen and (max-width: 350px) {
    width: 120px;
    height: 120px;
  }
  img {
    height: 166px;
    width: 166px;
    border-radius: 10px;
    @media screen and (max-width: 428px) {
      width: 140px;
      height: 140px;
    }
    @media screen and (max-width: 350px) {
      width: 120px;
      height: 120px;
    }
  }
}
.actions {
  padding: 0;
  gap: 12px;
  @media screen and (max-width: 920px) {
    flex-direction: column;
    gap: 14px;
    button {
      width: 100%;
    }
  }
}

.action-cancel {
  color: #000 !important;
  margin: 0 !important;
}

.qr {
  width: 80px;
  height: 80px;
  min-width: 80px;
  margin: 20px 12px;
  padding: 0;
  font-size: initial;
  line-height: initial;
}

.qr-mini {
  width: 30px;
  height: 30px;
  min-width: 30px;
  max-width: 30px;
  margin: 2px;
  padding: 0;
  font-size: initial;
  line-height: initial;
}

.banner-main {
  height: 344px;
  display: flex;
  align-items: center;
  margin: 0 20px 12px;
  @media screen and (max-width: 920px) {
    height: auto;
  }
  @media screen and (max-width: 428px) {
    margin: 0 0 12px;
  }
}
.banner-main-preview {
  display: flex;
  align-items: center;
  background-color: #fff !important;
  border-radius: 20px;
  img {
    max-width: 100%;
    border-radius: 20px;
  }
}

.blur-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  border: 2px solid #0A82D9;
  border-radius: 12px;
  height: 100%;
  background: rgba(255, 255, 255, 0.5);
  backdrop-filter: blur(1px);
  -webkit-backdrop-filter: blur(1px);
  z-index: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  img {
    width: 26px;
    height: 20px;
  }
}

::v-deep {
  .v-dialog {
    overflow-x: hidden !important;
    @media screen and (max-width: 599px) {
      margin: 12px !important;
    }
  }
  .v-list-item:not(.v-list-item--active):not(.v-list-item--disabled) {
    color: rgba(0, 0, 0, 0.5) !important;
  }
  .v-list-item--link:before {
    background-color: #fff !important;
  }
  .v-list-item--disabled {
    min-height: 0px !important;
  }
  .v-list-item {
    min-height: 28px;
    &__title {
      font-size: 16px !important;
      @media screen and (max-width: 428px) {
        font-size: 13px !important;
        line-height: 13px !important;
      }
      @media screen and (max-width: 350px) {
        font-size: 11px !important;
        line-height: 11px !important;
      }
    }
    &__content {
      padding: 4px 0;
    }
    &__action {
      margin: 0;
    }
  }

  .v-list {
    @media screen and (max-width: 428px) {
      max-height: 300px;
      overflow: auto;
    }
    .v-divider {
      margin: 10px 12px;
    }
  }

  .v-text-field__slot {
    input {
      height: 100%;
    }
  }

  .v-input {
    @media screen and (max-width: 428px) {
      font-size: 14px;
      line-height: 14px;
    }
    @media screen and (max-width: 350px) {
      font-size: 12px;
      line-height: 12px;
    }
  }
}

.selected-item {
  color: #0A82D9;
}

.category-title {
  color: rgba(0, 0, 0) !important;
  font-size: 14px !important;
  line-height: 20px;
}

.select-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.print-service-block {
  @media screen and (max-width: 768px) {
    margin-top: 30px;
  }
}
</style>

<i18n lang="yml" locale="ru">
  nowHiring: ищем сотрудников
  createQrDialogTitle: Создание макета с QR-кодом для печати
  dowloadBanner: Скачать макет
  cancel: Отмена
  bannerBackColor: Цвет фона
  bannerTextColor: Цвет текста
  bannerSize: Размер макета
  selectBannerSize: Выберите размер макета
  selectBannerBackColor: Выберите цвет фона
  selectBannerTextColor: Выберите цвет текста
  title1QR: ИЩЕМ
  title2QR: СОТРУДНИКОВ
  sticker: Стикер
  poster: Постер
  banner: Баннер
  printService: Сервис для печати
</i18n>
<i18n lang="yml" locale="en">
  nowHiring: now hiring
  createQrDialogTitle: Creating a layout with a QR code for printing
  dowloadBanner: Download the layout
  cancel: Cancel
  bannerBackColor: Background color
  bannerTextColor: Text color
  bannerSize: Layout size
  selectBannerSize: Select the layout size
  selectBannerBackColor: Select the background color
  selectBannerTextColor: Select the color
  title1QR: NOW
  title2QR: HIRING
  sticker: Sticker
  poster: Poster
  banner: Banner
  printService: Printing service
</i18n>
